import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {newsletterInteractionEmailList_template} from "../components/templates/newsletterInteractionEmailList_template";

declare var ko: any;
declare var page: any;

export class newsletter_interaction_emails extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected newsletterInteractionEmailList: newsletterInteractionEmailList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.newsletterInteractionEmailList = new newsletterInteractionEmailList_template("newsletterInteractionEmailList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Interaction Email List");
        return [this.newsletterInteractionEmailList.build()];
    }

    protected getModuleName(): string {
        return "newsletter_interaction_emails";
    }

    fillPage() {

        this.getNewsletterReferences();
    }

    protected filterList() {
        this.loadingIn(this.newsletterInteractionEmailList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.newsletterInteractionEmailList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/newsletter/interaction-emails/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterInteractionEmailDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetNewsletterInteractionEmailDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let newsletterInteractionEmails = responseParsed.data;

                obj.viewModel.newsletterInteractionEmailList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.newsletterInteractionEmailList.setResultInfo(totalCount, totalPage, execTime)

                obj.newsletterInteractionEmailList.setNewsletterInteractionEmails(newsletterInteractionEmails, obj.getBrandId())

            });
            obj.loadingOut(obj.newsletterInteractionEmailList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterInteractionEmailList.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/references';
        let usrReq_params: Array<Array<string>> = [['references', 'permissions,events,schedules']];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    public onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterInteractionEmailList.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterInteractionEmailList.setPermissions(responseParsed.permissions)
                obj.newsletterInteractionEmailList.setEvents(responseParsed.events || [])
                obj.newsletterInteractionEmailList.setSchedules(responseParsed.schedules || [])

                obj.filterList();
            })
        }
    }

    protected newsletterInteractionMailListReorder() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.filterList()
    }

    protected paginationOnPageClick() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.filterList();
    }

    protected viewNewsletterInteractionEmail(id) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/view/' + id + '/')
    }

    protected addNewsletterInteractionEmail() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/add/')
    }

    /** Deactivate an active Event Email from the list without touching queued deliveries. */
    public deactivateNewsletterInteractionEmail(id: number) {

        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const url = '/api/brand/' + idBrand + '/newsletter/interaction-emails/deactivate/' + id + '/';
        const request = new XMLHttpRequestHandler(url, [], this);
        request.mode = XMLHttpRequestHandler_requestType.POST;
        this.loadingIn(this.newsletterInteractionEmailList.builtTemplate.children.namedItem('list-results'));

        request.onReadyStateFunction = function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Event Email deactivated!');
                        obj.filterList();
                    }
                });
                obj.loadingOut(obj.newsletterInteractionEmailList.builtTemplate.children.namedItem('list-results'));
            };
        };
        request.execute();
    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.newsletterInteractionEmailList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_interaction_emails.ts